module.exports = __webpack_public_path__ + "static/media/009.58dfb751.jpg";